export default "__VITE_ASSET__CbgV4kYh__"